import GenericTwoFactorErrorAlert from '../alerts/GenericTwoFactorErrorAlert';
import NewCodeSentAlert from '../alerts/NewCodeSentAlert';
import SmsRateLimitAlert from '../alerts/SmsRateLimitAlert';
import UserDeactivatedAlert from '../alerts/UserDeactivatedAlert';
import BlockedLoginMethodAlert from '../alerts/BlockedLoginMethodAlert';
import RestrictedIpAddressAlert from '../alerts/RestrictedIpAddressAlert';
import HubspotAuthenticatorError from '../alerts/HubspotAuthenticatorError';
import { View } from 'foundations-components/transitional/components/View';
import { use2faAlerts } from './hooks/use2faAlerts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TwoFactorAlerts = ({
  onRestartTimer
}) => {
  const {
    isAnyAlertVisible
  } = use2faAlerts();
  if (!isAnyAlertVisible) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    paddingBlockEnd: "500",
    children: [/*#__PURE__*/_jsx(GenericTwoFactorErrorAlert, {}), /*#__PURE__*/_jsx(NewCodeSentAlert, {}), /*#__PURE__*/_jsx(SmsRateLimitAlert, {}), /*#__PURE__*/_jsx(UserDeactivatedAlert, {}), /*#__PURE__*/_jsx(BlockedLoginMethodAlert, {}), /*#__PURE__*/_jsx(RestrictedIpAddressAlert, {}), /*#__PURE__*/_jsx(HubspotAuthenticatorError, {
      restartTimer: onRestartTimer
    })]
  });
};